import React, { useEffect, useState } from "react";

import {
  TextField,
  Button,
  Autocomplete,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import { AgGridReact } from "ag-grid-react";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import {
  CircularProgress,
  Backdrop
} from "@mui/material";
import {
  GetSurveyReportList,
  GenerateVendorAllocation,
  SendVendorAllocation
} from "../../api/survey";

const SurveyIdsReport = () => {
  const [selectedSurvey, setSelectedSurvey] = useState(null);
  const [searchIds, setSearchIds] = useState("");
  const [surveys, setSurveys] = useState([]);
  const [vendorData, setVendorData] = useState([]);

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewData, setPreviewData] = useState(null);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] =
    useState("success");
  const [emailData, setEmailData] = useState({
  poNumber: "",
  emails: "",
  subject: "",
  body: ""
});
const [errors, setErrors] = useState({
  poNumber: "",
  emails: "",
  subject: "",
  body: ""
});
const [loading, setLoading] = useState(false);
const [sending, setSending] = useState(false);


  const showSnackbar = (
    message,
    severity = "success"
  ) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  useEffect(() => {
  loadSurveys();
}, []);

const loadSurveys = async () => {
  try {

    const response =
      await GetSurveyReportList();

    if (!response.errors) {
      setSurveys(response.result.data);
    }

  } catch (error) {
    console.error(error);

    showSnackbar(
      "Failed to load PDR list",
      "error"
    );
  }
};
const validateEmailPopup = () => {

  const newErrors = {};

  if (!emailData.poNumber.trim()) {
    newErrors.poNumber = "PO Number is required";
  }

  if (!emailData.emails.trim()) {
    newErrors.emails = "Email address is required";
  } else {

    const emails = emailData.emails
      .split(";")
      .map(e => e.trim())
      .filter(Boolean);

    const emailRegex =
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const invalidEmails = emails.filter(
      email => !emailRegex.test(email)
    );

    if (invalidEmails.length > 0) {
      newErrors.emails =
        "One or more email addresses are invalid";
    }
  }

  if (!emailData.subject.trim()) {
    newErrors.subject = "Subject is required";
  }

  if (!emailData.body.trim()) {
    newErrors.body = "Email body is required";
  }

  setErrors(newErrors);

  return Object.keys(newErrors).length === 0;
};
  const handleGenerate = async () => {
    if (!selectedSurvey) {
      showSnackbar(
        "Please select a PDR",
        "warning"
      );
      return;
    }

    console.log("Generating Vendor Allocation for Survey:", selectedSurvey, "with IDs:", searchIds);

    const ids = searchIds
      .split(/[,\n\r\s]+/)
      .filter(Boolean);

    if (!ids.length) {
      showSnackbar(
        "Please paste IDs",
        "warning"
      );
      return;
    }

    const totalIds = ids.length;
    console.log("Total IDs:", totalIds);
    console.log("Selected Survey ID:", selectedSurvey.id);

    const mockVendorData = [
      
    ];
    const payload = {
      surveyId: selectedSurvey.id,
      RespondentIds: ids,
    };

    const response = await GenerateVendorAllocation(payload);
    console.log("Vendor Allocation Response:", response.result.data.result.data);
    console.log("Mock Vendor Data:", mockVendorData);

    setVendorData(response.result.data.result.data || mockVendorData);

    showSnackbar(
      "Vendor allocation generated",
      "success"
    );
  };

  const handlePreview = (data) => {

  setPreviewData(data);

  setEmailData({
    poNumber: data.poNumber || "",
    emails: data.emails || "",
    subject: data.subject || "",
    body:data.body || `Dear Partner,

Please find attached respondent IDs for survey ${data.surveyId}.

Regards,
Pro Dynamic Research`
  });

  setPreviewOpen(true);
};

  const handleSendEmail = async () => {
    if (!validateEmailPopup()) {
    return;
  }

  try {
    //setloading(true);
    setSending(true);

    const payload = {
      surveyId: selectedSurvey.id,
      vendorId: previewData.vendorId,
      poNumber: emailData.poNumber,
      emails: emailData.emails,
      subject: emailData.subject,
      body: emailData.body
    };
    console.log("Sending email with payload:", payload);

    const response =
      await SendVendorAllocation(payload);

    if (!response.errors) {

      showSnackbar(
        "Email sent successfully",
        "success"
      );
      setPreviewOpen(false);

    } else {

      showSnackbar(
        "Failed to send email",
        "error"
      );
    }

  } catch (error) {

    console.error(error);

    showSnackbar(
      "Failed to send email",
      "error"
    );
  }
  finally {
    setSending(false);
  }
};

  const vendorColumnDefs = [
    {
      headerName: "Survey ID",
      field: "surveyId",
      flex: 1,
    },
    {
      headerName: "Vendor Name",
      field: "vendorName",
      flex: 1.5,
    },
    {
      headerName: "PO Number",
      field: "poNumber",
      editable: true,
      flex: 1.5,
    },
    {
      headerName: "Final IDs Count",
      field: "idsCount",
      flex: 1,
    },
    {
      headerName: "Subject Line",
      field: "subject",
      editable: true,
      flex: 2,
    },
    {
      headerName: "Email Box",
      field: "emails",
      editable: true,
      flex: 3,
    },
    {
  headerName: "Actions",
  flex: 1,
  cellRenderer: (params) => (
    <Button
      size="small"
      variant="outlined"
      onClick={() => handlePreview(params.data)}
    >
      Preview
    </Button>
  ),
}
  ];

  return (
    <>
    <div className="right-content w-100">
      <div className="card shadow border-0 p-4">

        <h4 className="mb-4">
          Vendor ID Distribution
        </h4>

        <div
          style={{
            display: "flex",
            gap: 15,
            alignItems: "flex-start",
            flexWrap: "wrap",
          }}
        >
          <Autocomplete
            sx={{ width: 400 }}
            options={surveys}
            value={selectedSurvey}
            onChange={(e, value) =>
              setSelectedSurvey(value)
            }
            getOptionLabel={(option) =>
              `${option.surveyName}`
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select PDR"
                size="small"
              />
            )}
          />

          <Button
            variant="contained"
            onClick={handleGenerate}
          >
            Generate Vendor Allocation
          </Button>
        </div>

        <div className="mt-3">
          <TextField
            fullWidth
            multiline
            minRows={6}
            maxRows={12}
            label="Paste Respondent IDs"
            value={searchIds}
            onChange={(e) =>
              setSearchIds(e.target.value)
            }
            placeholder={`RID001
RID002
RID003
RID004
RID005`}
          />
        </div>

        {vendorData.length > 0 && (
          <>
            <h5 className="mt-4 mb-3">
              Vendor Distribution
            </h5>

            <div
              className="ag-theme-quartz"
              style={{
                width: "100%",
                height: 400,
              }}
            >
              <AgGridReact
                rowData={vendorData}
                columnDefs={vendorColumnDefs}
                stopEditingWhenCellsLoseFocus={
                  true
                }
              />
            </div>
          </>
        )}
      </div>
</div>
      <Dialog
        open={previewOpen}
        onClose={() => setPreviewOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Email Preview
        </DialogTitle>

        <DialogContent>

  <TextField
    fullWidth
    margin="normal"
    label="PO Number"
    value={emailData.poNumber}
    error={!!errors.poNumber}
    helperText={errors.poNumber}
    onChange={(e) => {
        setEmailData({
            ...emailData,
            poNumber: e.target.value
        });

        setErrors({
            ...errors,
            poNumber: ""
        });
    }}
/>

  <TextField
    fullWidth
    margin="normal"
    label="Email Addresses"
    value={emailData.emails}
    error={!!errors.emails}
    helperText={
        errors.emails ||
        "Multiple emails separated by ;"
    }
    onChange={(e) => {
        setEmailData({
            ...emailData,
            emails: e.target.value
        });

        setErrors({
            ...errors,
            emails: ""
        });
    }}
/>

  <TextField
    fullWidth
    margin="normal"
    label="Subject"
    value={emailData.subject}
    error={!!errors.subject}
    helperText={errors.subject}
    onChange={(e) => {
        setEmailData({
            ...emailData,
            subject: e.target.value
        });

        setErrors({
            ...errors,
            subject: ""
        });
    }}
  />

  <TextField
    fullWidth
    multiline
    rows={8}
    margin="normal"
    label="Email Body"
    value={emailData.body}
    error={!!errors.body}
    helperText={errors.body}
    onChange={(e) => {
        setEmailData({
            ...emailData,
            body: e.target.value
        });

        setErrors({
            ...errors,
            body: ""
        });
    }}
  />

</DialogContent>
<DialogActions>

  <Button
    onClick={() =>
      setPreviewOpen(false)
    }
  >
    Cancel
  </Button>

  <Button
    variant="contained"
    disabled={sending}
    onClick={handleSendEmail}
>
    {sending ? (
        <CircularProgress
            size={20}
            color="inherit"
        />
    ) : (
        "Send Email"
    )}
</Button>

</DialogActions>
      </Dialog>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() =>
          setSnackbarOpen(false)
        }
      >
        <Alert
          severity={snackbarSeverity}
          variant="filled"
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default SurveyIdsReport;